import Placeholder from '@tiptap/extension-placeholder';
export default Placeholder.extend({
  addAttributes() {
    return {
      textAlign: {
        default: 'start',
        renderHTML: attributes => {
          return {
            style: `text-align: ${attributes.textAlign}`
          };
        }
      },
      direction: {
        default: 'ltr',
        renderHTML: attributes => {
          return {
            style: `direction: ${attributes.direction}`
          };
        }
      }
    };
  }
});